import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CheckTransactionType  {
    _originalTypeClassName = "zERP.BO.CheckTransactionType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CheckTransactionType.translate = translateService;
}
this.SupportedStatusesFrom = [];
this.Id = null;
this.Code = null;
this.Description = null;
this.CreatedAt = null;
this.ForIncomeChecks = false;
this.ForExpenseChecks = false;
this.FromEntityType = null;
this.ToEntityType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
CreatedAt:any;
ForIncomeChecks:any;
ForExpenseChecks:any;
FromEntityType:any;
ToEntityType:any;
SupportedStatusesFrom:any;
StatusAfterTransaction:any;
AccountingEvent:any;
static setSupportedStatusesFrom = ($this, items) => {
                if (items == null) items = [];
                if ($this.SupportedStatusesFrom == null) $this.SupportedStatusesFrom = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SupportedStatusesFrom.length > 0) {
                    Domain.CheckTransactionType.removeSupportedStatusesFrom($this, $this.SupportedStatusesFrom[0]);
                }

                Domain.CheckTransactionType.addManySupportedStatusesFrom($this, copyItems);
            }
static addManySupportedStatusesFrom = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.CheckTransactionType.addSupportedStatusesFrom($this, items[i]);
                }
            }
static addSupportedStatusesFrom = ($this, item) => {
                if ($this.SupportedStatusesFrom == null) $this.SupportedStatusesFrom = [];
                if (item == null || $this.SupportedStatusesFrom.indexOf(item) > -1) return;
                $this.SupportedStatusesFrom.push(item);
}
static addRangeSupportedStatusesFrom = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.CheckTransactionType.addSupportedStatusesFrom($this, item));
            }
static removeSupportedStatusesFrom = ($this, item) => {
                if ($this == null || $this.SupportedStatusesFrom == null || $this.SupportedStatusesFrom.indexOf(item) === -1) return;
                var _index = $this.SupportedStatusesFrom.indexOf(item);
                $this.SupportedStatusesFrom.splice(_index, 1);
}
static clearSupportedStatusesFrom = ($this) => { $this.SupportedStatusesFrom = null; }
static setStatusAfterTransaction = ($this, value) => {
var oldValue = $this.StatusAfterTransaction;
$this.StatusAfterTransaction = value;
if (value != null) {
}
}
static setAccountingEvent = ($this, value) => {
var oldValue = $this.AccountingEvent;
$this.AccountingEvent = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}